import { createFileRoute, Navigate } from "@tanstack/react-router";

import { ScreenSpinner } from "@/components";
import { useCareplan } from "@/domains/careplan/queries/use-careplan";
import { useProfile } from "@/domains/profile/queries/use-profile";
import { ProgressPageContent, ProgressPageError } from "@/domains/progress/components";
import { useProgress } from "@/domains/progress/queries/use-progress";
import { shouldLeaveProgressPage } from "@/domains/progress/utils/progress-availability";
import { selectIsProgressEnabled } from "@/domains/progress/utils/progress-entry-points";

const Progress = () => {
  const careplanQuery = useCareplan();
  const isProgressEnabled = selectIsProgressEnabled(careplanQuery.careplan);
  const progressQuery = useProgress({ enabled: isProgressEnabled });
  const profileQuery = useProfile();
  const isCareplanResolved = careplanQuery.careplan !== undefined;

  if (
    shouldLeaveProgressPage({
      careplanError: careplanQuery.error,
      isCareplanResolved,
      isProgressEnabled,
      progressError: progressQuery.error,
    })
  ) {
    return <Navigate to="/careplan" replace />;
  }

  if (!isCareplanResolved && careplanQuery.isError) {
    return (
      <ProgressPageError
        onRetry={() => {
          void careplanQuery.refetch();
        }}
      />
    );
  }

  if (progressQuery.isPending) {
    return <ScreenSpinner />;
  }

  if (progressQuery.isError && progressQuery.data === undefined) {
    return (
      <ProgressPageError
        onRetry={() => {
          void progressQuery.refetch();
        }}
      />
    );
  }

  return (
    <ProgressPageContent
      firstName={profileQuery.data?.firstName ?? ""}
      progress={progressQuery.data}
    />
  );
};

export const Route = createFileRoute("/_private/(with-footer)/progress/")({
  component: Progress,
});
